import { Route, Routes } from "react-router-dom";
import Loadable from 'react-loadable';
import PageLoader from "components/PageLoader";

const LazyPurchase = Loadable({
    loader: () => import("pages/Purchase/index"),
    loading: () => <PageLoader />,
});

const LazyPurchaseDetail = Loadable({
    loader: () => import("pages/PurchaseDetail/index"),
    loading: () => <PageLoader />,
});

const LazyPurchaseForm = Loadable({
    loader: () => import("pages/PurchaseForm/index"),
    loading: () => <PageLoader />,
});

const LazySupplier = Loadable({
    loader: () => import("pages/Supplier/index"),
    loading: () => <PageLoader />,
});

const LazyInventory = Loadable({
    loader: () => import("pages/Inventory/index"),
    loading: () => <PageLoader />,
});

const LazyInventoryItem = Loadable({
    loader: () => import("pages/PurchaseItem/index"),
    loading: () => <PageLoader />,
});


function PurchaseRoute() {
    return (
        <Routes>
            <Route path="/" element={<LazyPurchase />} />
            <Route path="/detail/:purchase_id" element={<LazyPurchaseDetail />} />
            <Route path="/create" element={<LazyPurchaseForm />} />
            <Route path="/suppliers" element={<LazySupplier />} />
            <Route path="/inventory" element={<LazyInventory />} />
            <Route path="/item" element={<LazyInventoryItem />} />
            {/* <Route path="/detail/:order_id" element={<LazyOrderDetail />} /> */}
        </Routes>
    );
}

export default PurchaseRoute;
